module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var attr = Html.attributes(locals.attributes); 
    ; __append("\n")
    ;  var checked = locals.checked ? locals.checked : []; 
    ; __append("\n")
    ;  var multiline = Util.coalesce(locals.multiline, true); 
    ; __append("\n\n")
    ;  for (var i = 0; i < items.length; i++) { 
    ; __append("\n")
    ;  var item = items[i]; 
    ; __append("\n")
    ;  var value = item[valueColumn]; 
    ; __append("\n")
    ;  var text = item[textColumn]; 
    ; __append("\n<label>\n	<input\n		")
    ; __append( attr )
    ; __append("\n		type=\"checkbox\"\n		value=\"")
    ; __append(escapeFn( value ))
    ; __append("\"\n		")
    ; __append( Html.checked(~checked.indexOf(value)) )
    ; __append("\n		>\n	<span>\n		")
    ; __append(escapeFn( text ))
    ; __append("\n	</span>\n	")
    ;  if (multiline && i < items.length - 1) { 
    ; __append("\n	<br>\n	")
    ;  } 
    ; __append("\n</label>\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}